// FaroErrorBoundary — catches React render errors, reports them to Faro RUM,
// and shows a minimal fallback instead of a blank screen. Works whether or not
// Faro is initialized (reportError is a no-op when RUM is off).
import React from "react";
import { reportError } from "./faro";

export default class FaroErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError(error, { componentStack: info && info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return React.createElement(
        "div",
        { style: { padding: 24, fontFamily: "sans-serif" } },
        React.createElement("h2", null, "Something went wrong."),
        React.createElement(
          "button",
          { onClick: () => window.location.reload() },
          "Reload"
        )
      );
    }
    return this.props.children;
  }
}
